export const hotTags = [
  { name: "独居生活", hot: 9820 },
  { name: "微服务", hot: 8610 },
  { name: "西北旅行", hot: 12430 },
  { name: "AI工具", hot: 11020 },
  { name: "职场成长", hot: 7640 },
  { name: "露营", hot: 6980 },
  { name: "甜品食谱", hot: 8320 },
  { name: "影评", hot: 5910 },
  { name: "早起", hot: 6740 },
  { name: "绿植", hot: 5460 },
  { name: "游戏交友", hot: 7130 },
  { name: "面试经验", hot: 8060 },
  { name: "出租屋改造", hot: 6210 },
  { name: "习惯养成", hot: 4870 },
];

export const siteStats = [
  { label: "注册成员", value: "128,600+", icon: "ri-group-line" },
  { label: "话题总数", value: "32,480", icon: "ri-chat-3-line" },
  { label: "今日新帖", value: "1,236", icon: "ri-add-circle-line" },
  { label: "活跃圈子", value: "260+", icon: "ri-fire-line" },
];